<template>
  <div>
    <el-form ref="batchImportForm" :model="formData" :rules="rules" label-width="80px">
      <el-form-item prop="storeId" label="归属门店">
        <QS-select
          v-model="formData.storeId"
          placeholder="请选择归属门店"
          filterable
          :option-data="storeList"
          :option-config="{
            labelKey: 'name',
            valueKey: 'id',
          }"
          >
        </QS-select>
      </el-form-item>
      <el-form-item label="下载模板">
        <div>
          <el-button type="primary" size="small">
            <a :href="templateUrl" class="download_link">下载模版</a>
          </el-button>
          <p class="import-tips">请按数据模板的格式准备要导入的数据</p>
        </div>
      </el-form-item>
      <el-form-item label="上传文件" prop="fileAddress">
        <div>
          <el-upload
            action=""
            accept=".xls,.xlsx"
            :fileList="formData.fileAddress"
            :limit="1"
            :http-request="uploadRequest"
            :autoUpload="true"
            :show-file-list="false"
          >
            <el-button
              :loading="upload.loading"
            >
            上传文件
            </el-button>
          </el-upload>
          <p v-for="(item, index) in formData.fileAddress" :key="index">{{item.name}}</p>
          <p class="import-tips">导入完成后，可在日志-导入记录中查看导入状态</p>
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="cancelSave">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveFormData">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { uploadTaskCreate } from '@/api/domain/others'
import { storeList } from '@/api/domain/shop'
import { uploadFile } from '@/api/domain/returnLease'
import { salesClueImportTemplate } from '@/config'

const downloadTemplate = salesClueImportTemplate
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        fileAddress: [],
        storeId: '',
      },
      rules: {
        storeId: [{ required: true, message: '请选择归属门店', trigger: 'change' }],
      },
      storeList: [],
      submitLoading: false,
      templateUrl: downloadTemplate,
      upload: {
        loading: false,
      },
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.submitLoading = false
        this.formData = {
          name: '',
          phone: '',
          storeId: '',
          channelType: '',
          channelId: '',
        }
        this.$nextTick(() => {
          this.$refs.batchImportForm.clearValidate()
        })
      }
    },
  },
  mounted() {
    this.getStoreList()
  },
  methods: {
    // 导入后创建任务
    saveFormData() {
      if (this.submitLoading) return
      this.$refs.batchImportForm.validate((valid) => {
        if (!valid) return
        if (this.formData.fileAddress.length === 0 || !this.formData.fileAddress[0].url) {
          this.$message.error('请上传文件')
          return
        }
        this.submitLoading = true
        const { url, name } = this.formData.fileAddress[0]
        uploadTaskCreate({
          fileAddress: url,
          fileName: name,
          uploadType: 66,
          extInfo: JSON.stringify({ storeId: this.formData.storeId }),
        }).then(({ code }) => {
          if (code !== 1) {
            this.submitLoading = false
            return
          }
          this.$emit('success')
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
    // 获取公司下的门店列表
    getStoreList() {
      storeList({
        pageNum: 1,
        pageSize: 9999,
      }).then(({ data }) => {
        this.storeList = data?.items || []
      })
    },
    cancelSave() {
      this.$emit('closeDialog')
    },
    async uploadRequest({ file }) {
      this.upload.loading = true
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('group', 'assert')
        formData.append('code', 'assert_batch_customer_lead_file')

        const { code, data } = await uploadFile(formData)
        if (code === 1) {
          this.formData.fileAddress = [{
            name: file.name,
            url: data,
          }]
        }
        this.upload.loading = false
      } catch (err) {
        this.upload.loading = false
        this.formData.fileAddress = []
      }
    },
  },
}
</script>
<style lang="less" scoped>
  .download_link {
    color: #fff;
    &:hover {
      color: #fff;
    }
  }
  .import-tips {
    font-size: 13px;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
</style>
